const jcs = require('../../jcs');

class HelpCenterCtrl {

	constructor($timeout, $http, Authentication) {
		'ngInject';

		this.$timeout = $timeout;
		this.$http = $http;
		this.auth = Authentication;

		this.is_loading = false;
		this.show_setup = false;
		this.setup_topic_error = false;

		this.WEB_PRO_LEGACY = "20351fc9-ae81-4483-8c1a-16097c2fb619";
		this.WEB_PRO_PLUS_SOCIAL = "30551fc2-b585-5348-8c13-36097c2f5613";
		this.WEB_ENTERPRISE = "40351fc9-be81-3483-8c1a-26097c2fb616";
		this.WEB_SOCIAL_ONLY = "50351fc5-be85-5348-8c15-56097c2f5615";
		this.WEB_DEMO = "71351fc9-be82-5483-8c1a-36097c2fb618";
		this.WEB_CAMPUS_REVIEW = "825607ee-1616-4d1f-b206-541eb8400227";
		this.WEB_BASIC_EMBED = "825607ee-1616-4d1f-b206-541eb8401590";
		this.WEB_STARTER = "d7e04d47-e349-4cb6-9072-c2002e48baf2";
		this.WEB_PRO = "f8362a41-7958-42ad-9db0-a94b738a86dd";

		this.WEB_PLANS_WITH_SOCIAL = [this.WEB_PRO_PLUS_SOCIAL, this.WEB_ENTERPRISE, this.WEB_SOCIAL_ONLY, this.WEB_STARTER, this.WEB_PRO];

		this.visible_setup_topics = [];
		this.all_setup_topics = [
			{
				title: 'Invite Team Members',
				subtitle: 'Allow your team to manage your streaming',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/invite-team-members',
				is_multisite: true,
				is_web: true,
				is_social: true,
			},
			{
				title: 'Customize Encoder Input',
				subtitle: 'Configure audio and video preferences',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/configuration-settings-for-adding-editing-or-copying-an-encoder-profile',
				is_multisite: true,
				is_web: true,
				is_social: true,
			},
			{
				title: 'Add Social Media Destinations',
				subtitle: 'Configure Facebook and YouTube destinations',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/add-social-media-account',
				is_multisite: false,
				is_web: false,
				is_social: true,
			},
			{
				title: 'Find Your Embed Code and Persistent URLs',
				subtitle: 'Share event content across preferred platforms',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/find-embed-code-and-persistent-urls',
				is_multisite: false,
				is_web: true,
				is_social: false,
			},
			{
				title: 'Schedule an Encoder Event',
				subtitle: 'Schedule events to capture content automatically',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/live-schedule-page-add-a-scheduled-encoder-event',
				is_multisite: true,
				is_web: false,
				is_social: false,
			},
			{
				title: 'Manually Interact with Your Encoder',
				subtitle: 'Start, stop, and configure your encoder',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/encoders-page-manually-start-and-stop-the-encoder',
				is_multisite: true,
				is_web: false,
				is_social: false,
			},
			{
				title: 'Schedule a Livestream with Social Destinations',
				subtitle: 'Schedule events to stream automatically',
				href: 'https://resi.clickhelp.co/articles/#!project-control-administration/live-schedule-page-add-scheduled-web-event-to-a-scheduled',
				is_multisite: false,
				is_web: true,
				is_social: true,
			},
			{
				title: 'Schedule a Sim-Live',
				subtitle: 'Schedule a video to stream as if it were live',
				href: 'https://resi.clickhelp.co/articles/#!project-control-administration/sim-live-schedule-page-add-a-scheduled-sim-live-event',
				is_multisite: false,
				is_web: true,
				is_social: true,
			},
			{
				title: 'Review Analytics',
				subtitle: 'See viewer details for embed code viewers',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/analytics',
				is_multisite: false,
				is_web: true,
				is_social: false,
			},
			{
				title: 'Load an Event on a Decoder',
				subtitle: 'View your multisite feed using a decoder',
				href: 'https://resi.clickhelp.co/articles/#!control-procedures-and-settings/load-an-event-on-a-decoder',
				is_multisite: true,
				is_web: false,
				is_social: false,
			},
		];
	}

	$onInit () {
		// watch for event when popup is closed, and reset popup to "home" page
		$('#help-center-btn').parent().on('hide.bs.dropdown', () => {
			this.$timeout(() => {
				this.show_setup = false;
			});
		});

		if (localStorage.getItem('controlPrefs.showSetupMenu')) {
			this.loadTopics();
			this.show_setup = true;
			$('#help-center-btn').dropdown('toggle');
			localStorage.removeItem('controlPrefs.showSetupMenu');
		}
	}

	close () {
		$('#help-center-btn').dropdown('toggle');
	}

	dropdownClick (event) {
		event.stopPropagation(); // prevent event from closing our popup
	}

	backToHome (event) {
		this.show_setup = false;
		event.stopPropagation(); // prevent event from closing our popup
	}

	setupResi (event) {
		this.show_setup = true;
		event.stopPropagation(); // prevent event from closing our popup

		if (this.visible_setup_topics.length === 0){
			this.loadTopics();
		}
	}

	loadTopics () {

		this.is_loading = true;
		this.setup_topic_error = false;

		this.$http.get(`${jcs.api.url_v3}/customers/${this.auth.getCurrentUser().customerID}`, { withCredentials: true})
		.then(response => {

			this.determineVisibleTopics(response.data.multisitePlanId, response.data.webPlanId);

		})
		.catch(reason => {

			this.setup_topic_error = true;

		}).finally(() => {

			this.is_loading = false;

		});
	}

	determineVisibleTopics (multisite_plan_id, web_plan_id) {

		const can_see_multisite_topics = multisite_plan_id !== null;
		const can_see_web_topics = web_plan_id !== null && web_plan_id !== this.WEB_SOCIAL_ONLY;
		const can_see_social_topics = this.WEB_PLANS_WITH_SOCIAL.includes(web_plan_id);

		this.visible_setup_topics = [];
		for (const topic of this.all_setup_topics){
			if ( (topic.is_multisite && can_see_multisite_topics) || (topic.is_web && can_see_web_topics) || (topic.is_social && can_see_social_topics) ){
				this.visible_setup_topics.push(topic);
			}
		}
	}
}

// example usage:
// <help-center></help-center>
//
export default class HelpCenterComponent {
	constructor() {
		this.template = require('./helpCenter.html').default;
		this.bindings = {};
		this.controller = HelpCenterCtrl;
	}
}
